module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/ekimae-kanri-387f78532f79be5f672842240b5935d1.png";